import React, {useEffect, useRef, useState} from 'react'
import {Link, navigate} from "@reach/router";
import {FiChevronDown, FiChevronUp, FiMenu, FiPower, FiSearch, FiDownload} from "react-icons/fi";
import {FaBell, FaRegBell, FaDownload} from "react-icons/fa";
import {MdModeEdit} from "react-icons/md";
import {Badge, Drawer, Popconfirm} from "antd";
import {addRTL, displayShareSheet, downloadApp, downloadPwa, localize, setHintDialog, switchReferral} from "../../helpers/functions";
import {Routes} from "../../routes/AppRouter";
import {useSelector} from "react-redux";
import Notifications from "../Notifications";
import {
    changeProfilePicture,
    dataURLtoFile,
    removeProfilePicture,
    resetProfilePicture,
    setDrawerVisible, showLogoutModel
} from "../../redux/actions/settingsActions";
import OutsideClickHandler from "react-outside-click-handler";
import {
    currentOperation, downloadAPK, facebookLink,
    feedbackEnabled,
    historyEnabled, instagramLink, iOS, isActive, isAndroid,
    isClipsRootPage, logoutDialog,
    logoutEnabled,
    menuTitleIn,
    myContentEnabled,
    referralEnabled,
    shareAsReferral,
    supportEnabled,
    supportLink,
    isYabadooOperation
} from "../../helpers/constants";
import {openLivePlayer} from "../../redux/actions/playerActions";
import {avatarIcon, iconCamera, menuCenterLogo, wideLogoMenu, ratingOff, ratingOn} from "../../assets/img/exports";
import {logout} from "../../redux/actions/authActions";
import {localStorageKeys, operations} from "../../helpers/enums";

const Menu = props => {
    const settings = useSelector(state => state.settings)
    const menu = useSelector(state => state.menu.menu)
    const playlistVisible = useSelector(state => state.playlist.visible)
    const referralState = useSelector(state => state.services.referralPopUp)
    const avatarInputRef = useRef()
    const [contentOpen, setContentOpen] = useState(true)
    const [searchKey, setSearchKey] = useState('')
    const [notificationsVisible, setNotificationsVisible] = useState(false)
    const scrollRef = useRef() // this ref just for infinite scrolling on the popup window
    const {rtl} = props
    const {username, network, avatar, fetchingAvatar, drawerVisible, giftCounter, profileFollowersNumber, profileNickname, profileDescription} = settings
    const refreshBadge = useSelector(state => state.player.unreadNotification)
    const unreadNotifications = !!localStorage.getItem(localStorageKeys.unreadNotifications) && localStorage.getItem(localStorageKeys.unreadNotifications) !== null ? localStorage.getItem(localStorageKeys.unreadNotifications) : ''
    const logo = menuCenterLogo

    const isActiveMenu = ({isCurrent}) => isCurrent ? {className: "menu-link selected"} : null
    const isActiveSubButton = ({isCurrent}) => isCurrent ? {className: "btn btn-dark-menu sub-menu selected"} : null
    const isActiveButton = ({isCurrent}) => isCurrent ? {className: "btn btn-dark-menu selected"} : null

    const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

    useEffect(() => {
    }, [refreshBadge])


    const menuItems = menu.map((item, index) => {
        if (item.id == '1') return (
            <Link key={index} to={Routes.channels} getProps={isActiveMenu} className={`menu-link`}>
                {localize('channels')}
            </Link>
        )
        if (item.id == '2') return (
            <Link key={index} to={Routes.movies} getProps={isActiveMenu} className={`menu-link`}>
                {localize('movies')}
            </Link>
        )
        if (item.id == '5') return (
            <Link key={index} to={Routes.bundles} getProps={isActiveMenu} className={`menu-link`}>
                {localize('bundles')}
            </Link>
        )
        if (item.id == '8') return (
            <Link key={index} to={Routes.clips} getProps={isActiveMenu} className={`menu-link`}>
                {localize('clips')}
            </Link>
        )
        if (item.id == '9') return (
            <Link key={index} to={Routes.shows} getProps={isActiveMenu} className={`menu-link`}>
                {localize('series')}
            </Link>
        )
        if (item.id == '13') return (
            <Link key={index} to={Routes.plays} getProps={isActiveMenu} className={`menu-link`}>
                {localize('plays')}
            </Link>
        )
        return null
    })

    const menuButtons = menu.map((item, index) => {
        if (item.id == '1') return (
            <Link key={index} to={Routes.channels} getProps={isActiveSubButton} className={`btn btn-dark-menu sub-menu`}>
                <span>{localize('channels')}</span>
            </Link>
        )
        if (item.id == '2') return (
            <Link key={index} to={Routes.movies} getProps={isActiveSubButton} className={`btn btn-dark-menu sub-menu`}>
                <span>{localize('movies')}</span>
            </Link>
        )
        if (item.id == '5') return (
            <Link key={index} to={Routes.bundles} getProps={isActiveSubButton} className={`btn btn-dark-menu sub-menu`}>
                <span>{localize('bundles')}</span>
            </Link>
        )
        if (item.id == '8') return (
            <Link key={index} to={Routes.clips} getProps={isActiveSubButton} className={`btn btn-dark-menu sub-menu`}>
                <span>{localize('clips')}</span>
            </Link>
        )
        if (item.id == '9') return (
            <Link key={index} to={Routes.shows} getProps={isActiveSubButton} className={`btn btn-dark-menu sub-menu`}>
                <span>{localize('series')}</span>
            </Link>
        )
        if (item.id == '13') return (
            <Link key={index} to={Routes.plays} getProps={isActiveSubButton} className={`btn btn-dark-menu sub-menu`}>
                <span>{localize('plays')}</span>
            </Link>
        )
        return null
    })

    const _handleKeyDown = e => {
        if (e.key === 'Enter' && searchKey.length >= 3) {
            navigate(Routes.searchTo(searchKey))
        }else if (e.key === 'Enter' && searchKey.length < 3){
            setHintDialog('searchKeyLength')
            // message.error(localize('searchKeyLength'))
        }
    }

    const _handleSearchClick = e => {
        if (searchKey.length >= 3) {
            navigate(Routes.searchTo(searchKey))
        }else{
            setHintDialog('searchKeyLength')
            // message.error(localize('searchKeyLength'))
        }
    }

    const onAvatarClickChange = () => {
        avatarInputRef.current.onchange = onAvatarBrowse
        avatarInputRef.current.click()
    }

    const onAvatarClickDelete = () => {
        if(avatar !== 'data:image/png;base64,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'){
            const file = dataURLtoFile(avatarIcon, 'avatar.png');
            removeProfilePicture(file)
        }
    }

    const onAvatarBrowse = e => {
        const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
        if (e.target.files && e.target.files[0] && validImageTypes.includes(e.target.files[0].type)) {
            const fr = new FileReader();
            fr.onload = () => {
                const url = window.URL || window.webkitURL;
                const image = new Image();
                image.onload = function() {
                    changeProfilePicture(e)
                };
                image.onerror = function() {
                    setHintDialog('chooseValidFile')
                };
                image.src = url.createObjectURL(e.target.files[0]);
            }
            fr.readAsText(e.target.files[0])
        }else {
            setHintDialog('chooseValidFile')
        }

    }

    const showReferral = () => {
        switchReferral(!referralState)
    }

    const checkModel = () => {
        if(logoutDialog){
            showLogoutModel(true)
        }else{
            logout()
        }
    }

    const [value, setValue] = useState(0);
    const handleCallback = () => {
        setValue(2);
    }

    const parseRating = () => {
        const ratingImageArray = [];
        const maxRating = 5
        for (let i = 1; i <= maxRating; i++) {
            if (i <= giftCounter) {
                ratingImageArray.push(ratingOn)
            } else {
                ratingImageArray.push(ratingOff)
            }
        }
        return ratingImageArray
    }

    return (
        <div className={`menu-container ${addRTL(rtl)} ${network === 'offline' ? 'offline' : ''}`}>
            <div className={`menu-left`}>
                <div className='clickable-light' onClick={() => setDrawerVisible(true)}>
                    <FiMenu className='menu-hamburger'/>
                </div>
                <div className={`menu-links`}>
                    <div className='vertical-divider'/>
                    {menuItems}
                </div>
            </div>
            <div className='menu-center'>
                <Link to='/home/'><img src={logo} alt="logo" className='menu-logo'/></Link>
                {menuTitleIn ? <p className='title'>{localize('menuTitle')}</p> : null}
            </div>
            <div className={`menu-right`}>
                {navigator.share && referralEnabled ? (
                    <div className='clickable-light menu-bell' onClick={() => showReferral()}>
                        <img src={require('../../assets/img/icons/referal_icon.png')} alt='' className={`menu-bell-icon`} style={{width:'30px'}}/>
                    </div>
                ) : null}
                <div className='menu-input-icon'>
                    <input type="text" placeholder={localize('search')} value={searchKey} onKeyDown={_handleKeyDown} onChange={e => setSearchKey(e.target.value)}/>
                    <span onClick={_handleSearchClick}><FiSearch className='menu-search-icon'/></span>
                </div>
                {notificationsVisible ? (
                    <div className='clickable-light menu-bell'>
                        <Badge count={unreadNotifications}>
                            <FaBell className='menu-bell-icon'/>
                        </Badge>
                    </div>
                ) : (
                    <div className='clickable-light menu-bell' onClick={() => setNotificationsVisible(!notificationsVisible)}>
                        <Badge count={unreadNotifications}>
                            <FaRegBell className='menu-bell-icon'/>
                        </Badge>
                    </div>
                )}
            </div>
            <div className="menu-right-mobile">
                {navigator.share && referralEnabled ? (
                <div className='clickable-light d-lg-none menu-bell' onClick={() => showReferral()}>
                    <img src={require('../../assets/img/icons/referal_icon.png')} alt='' className={`menu-bell-icon`} style={{width:'30px'}}/>
                </div>
                ) : null}
                <Link to='/search/' className='clickable-light d-lg-none menu-bell'>
                    <FiSearch className='menu-hamburger'/>
                </Link>
                <Link to={Routes.notifications} className='clickable-light d-lg-none menu-bell'
                      getProps={({isCurrent}) => isCurrent ? {className: "clickable-light d-lg-none menu-bell notification-menu-selected"} : null}>
                    <Badge count={unreadNotifications}>
                        <FaBell className='menu-bell-icon selected'/>
                        <FaRegBell className='menu-bell-icon'/>
                    </Badge>
                </Link>
                {/*{(iOS && !isInStandaloneMode()) ? (*/}
                {/*    <div className='clickable-light menu-bell' onClick={() => downloadPwa()}>*/}
                {/*        <FiDownload className={`menu-bell-icon`}/>*/}
                {/*    </div>*/}
                {/*) : null}*/}
                {isClipsRootPage ? null : (
                    <div className='clickable-light menu-bell' onClick={() => !playlistVisible ? openLivePlayer() : null}>
                        <img src={require('../../assets/img/icons/watchnow1.png')} alt='' className={`menu-bell-icon`}/>
                        {/*<FiTv className='menu-bell-icon'/>*/}
                    </div>
                )}
            </div>

            <Drawer
                placement={rtl ? 'right' : 'left'}
                closable={false}
                onClose={() => setDrawerVisible(false)}
                visible={drawerVisible}
                className={`${addRTL(rtl)} ${network === 'offline' ? 'offline' : ''}`}
                width={320}
            >

                <div className={`drawer-avatar-container ${addRTL(rtl)}`}>
                    <img src={wideLogoMenu} alt="logo" className='drawer-logo'/>
                    <p className='drawer-slogan'>{localize('enjoyableEntertainment')}</p>
                    <div className='profile-container'>
                        <div className='drawer-avatar'>
                            {fetchingAvatar ? (
                                <div className="drawer-avatar-overlay">
                                    <span className="spinner-border text-light"/>
                                </div>
                            ) : (
                                isYabadooOperation ?
                                <div className="drawer-avatar-overlay" style={isYabadooOperation ? {cursor:'unset'} : null}>
                                    {/*<img src={iconCamera} className={'icon-camera'}/>*/}
                                </div> :
                                <Popconfirm
                                    title={localize('changeAvatarMsg')}
                                    // visible={confirmAvatarVisible}
                                    onConfirm={onAvatarClickDelete}
                                    onCancel={onAvatarClickChange}
                                    okText={localize('delete')}
                                    okType='default'
                                    cancelText={localize('change')}
                                    placement='bottom'
                                >
                                    <div className="drawer-avatar-overlay">
                                        <img src={iconCamera} className={'icon-camera'}/>
                                        {/*<FiCamera/>*/}
                                    </div>
                                </Popconfirm>
                            )}
                            <input type='file' accept="image/*" ref={avatarInputRef}/>
                            <img src={avatar} alt="avatar" onError={() => resetProfilePicture()}/>
                        </div>
                        <div className='user-profile'>
                            <div className='user-details'>
                                <p style={{fontFamily:"Arial Rounded MT Bold"}}>{!!profileNickname ? profileNickname : localize('nickname')}</p>
                                <p>{!!profileDescription ? profileDescription : localize('description')}</p>
                                {!!profileFollowersNumber ? <p onClick={() => profileFollowersNumber !== '0' ? navigate(Routes.followers) : null} className='followers'>{localize('followers') + ': ' } <span>{profileFollowersNumber}</span></p> : null}
                            </div>
                            <div className='edit-icon' onClick={() => navigate(Routes.userProfile)}>
                                <MdModeEdit/>
                            </div>
                        </div>
                    </div>

                    <div className={`drawer-info ${addRTL(rtl)}`}>
                        <p className='drawer-info-title'>{localize('userProfile')}</p>
                        <p className='drawer-info-desc'>{username}</p>
                    </div>
                    <div className={`drawer-info ${addRTL(rtl)}`}>
                        <p className='drawer-info-title'>{localize('operatorName')}</p>
                        {/*<p className='drawer-info-desc'>{localStorage.getItem(localStorageKeys.currentOperation)}</p>*/}
                        <p className='drawer-info-desc'>{localStorage.getItem(localStorageKeys.operatorName)}</p>
                    </div>
                    {/*<div className={`drawer-info ${addRTL(rtl)}`} style={!!giftCounter ? {borderBottom:'3px solid #253d50',paddingBottom:'0.2rem'} : null}>*/}
                    {/*    <p className='drawer-info-title'>{localize('paymentMethod')}</p>*/}
                    {/*    <p className='drawer-info-desc'>{localize('fromPhoneCredit')}</p>*/}
                    {/*</div>*/}

                    <div className='media-info'>
                        {/*fb://page?id=YabadooCameroon  // ios 'fb://profile?id=YabadooCameroon'*/ }
                        <a href={facebookLink} target="_blank"><img src={require('../../assets/img/icons/facebook.png')}/></a>
                        <a href={instagramLink} target="_blank"><img src={require('../../assets/img/icons/instagram-icon.png')}/></a>
                    </div>

                    {!!giftCounter ?
                        <div className='gift-dialog'>
                            <div className='rate-element'>
                                {parseRating().map((item,i) => <img key={i} src={item}/>)}
                                <img className='gift-icon' src={require('../../assets/img/icons/gift_streek.png')} onClick={() => setHintDialog('loyalityStreakDesc',localize('loyalityStreakTitle'))}/>
                            </div>
                            <p>{localize(`loyalityStreak${giftCounter}`)}</p>
                        </div>
                        : null}

                </div>
                {!!currentOperation && currentOperation === operations.mtnClipSyria ?
                    <Link to={Routes.clips} getProps={isActiveButton} className={`btn btn-dark-menu`}>
                        {/*<FiHome className={`drawer-icon`}/>*/}
                        <img src={require('../../assets/img/icons/ic_home.png')} alt='' className={`drawer-icon`}/>
                        {localize('home')}
                    </Link>
                    :
                    <Link to={Routes.root} getProps={isActiveButton} className={`btn btn-dark-menu`}>
                        {/*<FiHome className={`drawer-icon`}/>*/}
                        <img src={require('../../assets/img/icons/ic_home.png')} alt='' className={`drawer-icon`}/>
                        {localize('home')}
                    </Link>
                }
                <div className="d-block d-lg-none">

                    <button className={`btn btn-dark-menu w-100`} onClick={() => setContentOpen(!contentOpen)}>
                        {contentOpen ? <FiChevronUp className={`drawer-icon`}/> : <FiChevronDown className={`drawer-icon`}/>}
                        {localize('theContent')}
                    </button>
                    {contentOpen ? menuButtons : null}
                </div>
                {myContentEnabled ? (
                    <Link to={Routes.myContent} getProps={isActiveButton} className={`btn btn-dark-menu`}>
                        {/*<FiVideo className={`drawer-icon`}/>*/}
                        <img src={require('../../assets/img/icons/ic_mycontent.png')} alt='' className={`drawer-icon`}/>
                        {localize('myContent')}
                    </Link>
                ) : null}
                <Link to={Routes.favorites} getProps={isActiveButton} className={`btn btn-dark-menu`}>
                    {/*<FiHeart className={`drawer-icon`}/>*/}
                    <img src={require('../../assets/img/icons/favourite.png')} alt='' className={`drawer-icon`}/>
                    {localize('favorites')}
                </Link>
                {historyEnabled ? (
                    <Link to={Routes.history} getProps={isActiveButton} className={`btn btn-dark-menu`}>
                        {/*<FiClock className={`drawer-icon`}/>*/}
                        <img src={require('../../assets/img/icons/ic_history.png')} alt='' className={`drawer-icon`}/>
                        {localize('history')}
                    </Link>
                ) : null}
                {feedbackEnabled ? (
                    <Link to={Routes.feedback} getProps={isActiveButton} className={`btn btn-dark-menu`}>
                        {/*<FiHelpCircle className={`drawer-icon`}/>*/}
                        <img src={require('../../assets/img/icons/ic_feedback.png')} alt='' className={`drawer-icon`}/>
                        {localize('feedback')}
                    </Link>
                ) : null}
                {/*{supportEnabled && currentOperation === operations.senegal ? (*/}
                {/*    <a href={supportLink} className={`btn btn-dark-menu`}>*/}
                {/*        <img src={require('../../assets/img/icons/support.png')} alt='' className={`drawer-icon`}/>*/}
                {/*        {localize('support')}</a>*/}
                {/*) : supportEnabled ? (*/}
                {/*    <Link to={Routes.support} className={`btn btn-dark-menu`}>*/}
                {/*        <img src={require('../../assets/img/icons/support.png')} alt='' className={`drawer-icon`}/>*/}
                {/*        {localize('support')}*/}
                {/*    </Link>*/}
                {/*) : null}*/}
                {supportEnabled ? <a href={supportLink} className={`btn btn-dark-menu`}>
                    <img src={require('../../assets/img/icons/support.png')} alt='' className={`drawer-icon`}/>
                    {localize('support')}</a> : null}

                <Link to={Routes.settings} getProps={isActiveButton} className={`btn btn-dark-menu`}>
                    {/*<FiSettings className={`drawer-icon`}/>*/}
                    <img src={require('../../assets/img/icons/ic_setting.png')} alt='' className={`drawer-icon`}/>
                    {localize('settings')}
                </Link>

                {navigator.share ? (
                    <Link to={Routes.root} onClick={() => shareAsReferral ? showReferral() : displayShareSheet()} className={`btn btn-dark-menu`}>
                        <img src={require('../../assets/img/icons/share_app.png')} alt='' className={`drawer-icon`}/>
                        {localize('share')}
                    </Link>
                    // <button className={`btn btn-dark-menu`} onClick={() => shareAsReferral ? showReferral() : displayShareSheet()}>
                    //     {/*<FiShare className={`drawer-icon`}/>*/}
                    //     <img src={require('../../assets/img/icons/share_app.png')} alt='' className={`drawer-icon`}/>
                    //     {localize('share')}
                    // </button>
                ) : null}
                {isAndroid && downloadAPK ? (
                    <button className={`btn btn-dark-menu`} onClick={() => downloadApp()}>
                        <FaDownload className={`drawer-icon`}/>
                        {localize('downloadAndroid')}
                    </button>
                 ) : null}
                {logoutEnabled ? (
                    <Link to={Routes.root} onClick={() => checkModel()} className={`btn btn-dark-menu`}>
                        <FiPower className={`drawer-icon`}/>
                        {/*<img src={require('../../assets/img/icons/ic_home.png')} alt='' className={`drawer-icon`}/>*/}
                        {localize('logout')}
                    </Link>
                    // <button className={`btn btn-dark-menu`} onClick={() => checkModel()}>
                    //     <FiPower className={`drawer-icon`}/>
                    //     {localize('logout')}
                    // </button>
                ) : null}
            </Drawer>

            {!notificationsVisible ? null : (
                <OutsideClickHandler
                    onOutsideClick={() => {
                        if (notificationsVisible) setNotificationsVisible(false)
                    }}
                >
                    <div className="popup-container" ref={scrollRef}>
                        <Notifications scrollRef={scrollRef} onClick={() => notificationsVisible ? setNotificationsVisible(false) : null}
                        />
                    </div>
                </OutsideClickHandler>
            )}


        </div>
    )
}

export default Menu
